import { render, staticRenderFns } from "./DouleurContainer.vue?vue&type=template&id=235bcc5c&"
import script from "./DouleurContainer.vue?vue&type=script&lang=js&"
export * from "./DouleurContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports